export default [
  {
    path: '/:slug/tax/overview',
    name: 'tax.overview',
    component: () => import('../pages/overview-page.vue'),
  },
  {
    path: '/:slug/tax/entities',
    name: 'tax.filing-locators',
    component: () => import('../pages/entities-page.vue'),
    meta: {},
  },
  {
    path: '/:slug/tax/entities',
    name: 'tax.entities',
    component: () => import('../pages/entities-page.vue'),
    meta: {},
  },
  {
    path: '/:slug/tax/filing-locators/:filingLocatorId/documents',
    component: () => import('../pages/filing-locators/[filingLocatorId]/documents/index.vue'),
    name: 'tax.filing-locator.documents',
  },
]
